import { GridContainer } from '@bob/library'
import { PageContext } from '@websrc/App/AppContext'
import { AppProvider } from '@websrc/App/AppProvider'
import { Steps } from '@websrc/App/Components/Lesson/Steps/Steps'
import { SimpleTopbar } from '@websrc/App/Components/SimpleTopbar/SimpleTobbar'
import { pathToPageName } from '@websrc/App/Helpers/pathToPageName'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapWorksheet } from '@websrc/DataMappers/mapWorksheet'
import React, { FC } from 'react'

import * as SC from './StudentWorksheetPage.style'

export type StudentWorksheetProps = ReturnType<typeof mapWorksheet>

export const StudentWorksheet = ({ parentUrl, steps, title }: StudentWorksheetProps) => {
  const t = useStaticText()

  return (
    <>
      <SimpleTopbar>
        <SC.LinkButton to={parentUrl}>
          {t.plans_lessons_worksheets.back_to_lesson_plan}
        </SC.LinkButton>
      </SimpleTopbar>
      <GridContainer>
        <SC.ContentWrapper desktop={6} giant={4} tablet={8}>
          <SC.HeaderWrapper>
            <SC.Title>{title}</SC.Title>
          </SC.HeaderWrapper>

          <SC.StepsWrapper>
            <Steps steps={steps} />
          </SC.StepsWrapper>
        </SC.ContentWrapper>
      </GridContainer>
    </>
  )
}

export interface StudentWorksheetPageProps {
  pageContext: PageContext & {
    worksheet: StudentWorksheetProps
  }
}

const StudentWorksheetPage: FC<StudentWorksheetPageProps> = ({ pageContext }) => {
  const { appContext, worksheet } = pageContext
  const [siteSection, pageName] = pathToPageName(appContext.path)
  const pageType = 'student-worksheet'

  return (
    <AppProvider {...appContext} pageName={pageName} pageType={pageType} siteSection={siteSection}>
      <StudentWorksheet {...worksheet} />
    </AppProvider>
  )
}

export default StudentWorksheetPage
